<div class="review_box">
    <div class="review_box_content">
        <div class="review_box_content_header">
            <p>Add Code Review</p>     
        </div>
        <div class="review_box_content_content">
            <form [formGroup]="codeReviewForm" (ngSubmit)="onSubmitAdd()">
                <ul>
                    <li><input type="text" formControlName="title" placeholder="Title" required></li>
                    <li><mat-select formControlName="artifactType" required
                            (selectionChange)="onArtifactTypeChange($event.value)" [disabled]="isArtifactProvided">
                            <mat-option *ngFor="let type of artifactTypes" [value]="type">{{ type }}</mat-option>
                        </mat-select></li>
                    <li><mat-select formControlName="artifact" required 
                            (selectionChange)="onArtifactChange($event.value)" [disabled]="isArtifactProvided">
                            <mat-option *ngFor="let artifact of artifactNameOptions" [value]="artifact">{{
                                artifact.artifactName }}</mat-option>
                        </mat-select></li>
                    <li><mat-select formControlName="reviewers" multiple>
                            <mat-option *ngFor="let reviewer of reviewerOptions" [value]="reviewer">{{ reviewer.name
                                }}</mat-option>
                        </mat-select></li>
                    <li>
                        <mat-select formControlName="reportArtifact" required
                            (selectionChange)="onReportArtifactChange($event.value)">
                            <mat-option *ngFor="let reportArtifact of reportArtifactNameOptions" [value]="reportArtifact">
                                {{ reportArtifact.artifactName }}
                            </mat-option>
                        </mat-select>
                        <mat-select formControlName="report">
                            <mat-option *ngFor="let report of artifactReports" [value]="report">
                                <span>
                                    {{ report.startTime | date:'MMM d, yyyy, h:mm a' }} | {{ report.createdBy}}
                                </span>
                            </mat-option>
                        </mat-select>
                    </li>
                    <li class="textarea_li"><textarea type="text-area" formControlName="description"
                            placeholder="Description"></textarea>
                    </li>
                </ul>
                <div class="codeReview_btn">
                    <button type="submit" [disabled]="!codeReviewForm.valid" [featureActionState]="'CODE_REVIEW'">Submit</button>
                    <button (click)="close()">Cancel</button>
                </div>
            </form>
        </div>
    </div>
</div>